import React from 'react';
import { doc, collection, query, where, orderBy, limit, onSnapshot } from 'firebase/firestore';
import { useNavigate, useParams } from 'react-router-dom';

import MsgNetLoading from '../components/MsgNetLoading';
import TopHeaderMenu from '../components/TopHeaderMenu';
import RankingSelector from '../components/RankingSelector';
import RankingResultadoList from '../components/RankingResultadoList';
import CompeticionHeaderMenu from '../components/CompeticionHeaderMenu';
import CONFIG from '../config';
import SharePanel from '../components/SharePanel';
import { FirebaseContext } from '../index';

class RankingScreenClass extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      resultados: [],
      rankings: [],
      ranking: null,
      competicion: null,
      evento: null,
      showSharePanel: false
    };
    this.unlisten = {
      resultados: null
    };
  }

  componentDidMount() {
    const { db, params } = this.props;
    const competicionId = parseInt(params.competicionId, 10);
    const rankingId = parseInt(params.rankingId, 10);

    // Competición
    const competicionRef = doc(db, 'competicion', competicionId.toString());
    this.unlisten.competicion = onSnapshot(competicionRef, (snapshot) => {
      let competicion = snapshot.exists() ? snapshot.data() : null;
      if (competicion) {
        competicion.id = snapshot.id;
      }
      this.setState({ competicion });
    });

    // Rankings
    const rankingsQuery = query(
      collection(db, 'ranking'),
      where('competicion_id', '==', competicionId),
      limit(CONFIG.NUMERO_MAXIMO_RANKINGS)
    );

    this.unlisten.rankings = onSnapshot(rankingsQuery, (snapshot) => {
      let rankings = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      let ranking = null;
      if (rankingId) {
        ranking = rankings.filter((r) => parseInt(r.id, 10) === rankingId);
        if (ranking.length) {
          ranking = ranking[0];
        }
      } else if (rankings.length) {
        ranking = rankings[0];
      }
      this.setState({ rankings, ranking });
    });
  }

  componentWillUpdate(nextProps, nextState) {
    const { db } = this.props;

    if (this.state.competicion !== nextState.competicion) {
      if (nextState.competicion) {
        // Validar y convertir evento_id a string
        const eventoId = nextState.competicion.evento_id;

        if (eventoId) {
          const eventoRef = doc(db, 'evento', String(eventoId));
          this.unlisten.evento = onSnapshot(eventoRef, (snapshot) => {
            let evento = snapshot.exists() ? snapshot.data() : null;
            if (evento) {
              evento.id = snapshot.id;
            }
            this.setState({ evento });
          });
        }
      }
    }

    if (this.state.ranking !== nextState.ranking) {
      if (nextState.ranking) {
        // Limpiar listener anterior de resultados
        if (this.unlisten.resultados) {
          this.unlisten.resultados();
        }

        const resultadosQuery = query(
          collection(db, 'ranking_resultado'),
          where('ranking_id', '==', parseInt(nextState.ranking.id, 10)),
          where('puesto', '>', 0),
          orderBy('puesto', 'asc'),
          limit(CONFIG.NUMERO_MAXIMO_RESULTADOS)
        );

        this.unlisten.resultados = onSnapshot(resultadosQuery, (snapshot) => {
          let resultados = snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }));
          this.setState({ resultados });
        });
      }
    }

    if (this.props.params.rankingId !== nextProps.params.rankingId) {
      let ranking = null;
      const rankingId = parseInt(nextProps.params.rankingId, 10);
      if (rankingId) {
        ranking = this.state.rankings.filter((r) => parseInt(r.id, 10) === rankingId);
        if (ranking.length) {
          ranking = ranking[0];
        }
      } else if (this.state.rankings.length) {
        ranking = this.state.rankings[0];
      }
      this.setState({ ranking });
    }
  }

  onClickBack() {
    this.props.navigate(`/${this.state.competicion.evento_id}`);
  }

  toogleSharePanel() {
    this.setState(state => ({
      showSharePanel: !this.state.showSharePanel
    }));
  }

  componentWillUnmount() {
    if (this.unlisten.evento) {
      this.unlisten.evento();
    }
    if (this.unlisten.competicion) {
      this.unlisten.competicion();
    }
    if (this.unlisten.rankings) {
      this.unlisten.rankings();
    }
    if (this.unlisten.resultados) {
      this.unlisten.resultados();
    }
  }

  render() {
    const evento = this.state.evento;
    const ranking = this.state.ranking;
    const rankings = this.state.rankings;
    const resultados = this.state.resultados;
    const competicion = this.state.competicion;

    if (competicion) {
      return (
        <div>
          <TopHeaderMenu
            onClickBack={this.onClickBack.bind(this)}
            onClickShare={this.toogleSharePanel.bind(this)}
            competicion={competicion}
            evento={evento}
          />
          <CompeticionHeaderMenu
            competicion={competicion}
            selected={2}
            evento={evento}
          />
          <div className="pt-32">
            <RankingSelector competicion={competicion} rankings={rankings} ranking={ranking} />
            <RankingResultadoList ranking={ranking} resultados={resultados} />
          </div>

          {this.state.showSharePanel && (
            <SharePanel
              close={this.toogleSharePanel.bind(this)}
              url={`/competicion/${competicion.id}/ranking/${ranking.id}`}
              title={`${ranking.header} en la prueba ${competicion.nombre} (${evento.nombre})`}
            />
          )}
        </div>
      );
    } else {
      return <MsgNetLoading />;
    }
  }
}

// Wrapper funcional
function RankingScreen() {
  const navigate = useNavigate();
  const params = useParams();
  const { db } = React.useContext(FirebaseContext);

  return <RankingScreenClass navigate={navigate} params={params} db={db} />;
}

export default RankingScreen;